import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'

import moment from 'moment'
import _ from 'lodash'
import { Button, Card, Col, InputNumber, Row, Select, notification } from 'antd'

import Request from '../../request'

import { connect } from 'react-redux'
import styles from './styles.less'
import { hideLoader, showLoader } from '../../modules/actions'
import common from '../common.less'
import userRights from '../../components/_utils/userRights'
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

const Option = Select.Option

const maritalStatus = [
    'Single',
    'Married',
    'Separated',
    'Divorced',
    'Engaged'
];

const atLevels = [
    { name: 'Counselling Desk', value: 'Front Desk' },
    { name: 'Dead Inquiry', value: 'Dead Inquiry' },
    { name: 'Registration Desk', value: 'Registration Desk' },
    { name: 'Deleted', value: 'Deleted' },
    { name: 'Visa Desk', value: 'Visa Desk' },
    { name: 'Application Desk', value: 'Application Desk' },
    { name: 'Claim Desk', value: 'Claim Desk' },
    { name: 'Archive Desk', value: 'Archive Desk' }
]

const gender = ['Male', 'Female']
const modes = ['Personal', 'Telephone', 'Facebook', 'Website', 'Google']
const confirmOptions = ['No', 'Yes']
const invoiceTypesList = ['Channel Partner', 'University']
const testTypes = ['PTE', 'TOEFL', 'CAE', 'IELTS']
const followUpTypeArr = ['Didn\'t Pick up Call', 'Busy, Call Later', 'Not Interested', 'Out Of town', 'Cold', 'Active']
const studentStatus = ['Ongoing', 'Not Enrolled Yet', 'Max Commission Paid', 'Withdrawn - Bad Debts']
const enqTypes = ['Under Graduate', 'Post Graduate', 'Schooling']
const sourceOptions = ['Direct', 'Newspaper', 'Facebook', 'Google',
    'Seminar', 'Education Fair', 'School/College Event', 'Conopy', 'Instagram', 'Justdial']
const typeofDegree = {
    Diploma: [
        { key: 'Diploma Of Engineering', value: 'Diploma Of Engineering' },
        { key: 'Diploma Of Management', value: 'Diploma Of Management' }
    ],
    'Bachelor Degree': [
        { key: 'Bachelor of Agriculture', value: 'Bachelor of Agriculture' },
        { key: 'Bachelor of Arts', value: 'Bachelor of Arts' },
        {
            key: 'Bachelor of Ayurvedic Medicine & Surgery - BAMS',
            value: 'Bachelor of Ayurvedic Medicine & Surgery - BAMS'
        },
        {
            key: 'Bachelor of Business Administration',
            value: 'Bachelor of Business Administration'
        },
        { key: 'Bachelor of Commerce', value: 'Bachelor of Commerce' },
        {
            key: 'Bachelor of Computer Applications',
            value: 'Bachelor of Computer Applications'
        },
        {
            key: 'Bachelor of Computer Science',
            value: 'Bachelor of Computer Science'
        },
        {
            key: 'Bachelor of Dental Surgery - BDS',
            value: 'Bachelor of Dental Surgery - BDS'
        },

        { key: 'Bachelor of Design', value: 'Bachelor of Design' },
        { key: 'Bachelor of Education', value: 'Bachelor of Education' },
        { key: 'Bachelor of Engineering', value: 'Bachelor of Engineering' },
        { key: 'Bachelor of Fine Arts', value: 'Bachelor of Fine Arts' },
        { key: 'Bachelor of Home Science', value: 'Bachelor of Home Science' },

        {
            key: 'Bachelor of Homeopathic Medicine and Surgery - BHMS',
            value: 'Bachelor of Homeopathic Medicine and Surgery - BHMS'
        },
        { key: 'Bachelor of Laws', value: 'Bachelor of Laws' },
        {
            key: 'Bachelor of Mass Communications',
            value: 'Bachelor of Mass Communications'
        },
        {
            key: 'Bachelor of Medicine and Bachelor of Surgery (MBBS)',
            value: 'Bachelor of Medicine and Bachelor of Surgery (MBBS)'
        },
        { key: 'Bachelor of Nursing', value: 'Bachelor of Nursing' },
        { key: 'Bachelor of Pharmacy', value: 'Bachelor of Pharmacy' },
        { key: 'Bachelor of Physiotherapy', value: 'Bachelor of Physiotherapy' },
        { key: 'Bachelor of Science', value: 'Bachelor of Science' },
        { key: 'Bachelor of Social Work', value: 'Bachelor of Social Work' },
        { key: 'Bachelor of Technology', value: 'Bachelor of Technology' },
        {
            key: 'Bachelor of Veterinary Science & Animal Husbandry',
            value: 'Bachelor of Veterinary Science & Animal Husbandry'
        },
        { key: 'Doctor of Medicine', value: 'Doctor of Medicine' },
        {
            key: 'Doctor of Medicine in Homoeopathy',
            value: 'Doctor of Medicine in Homoeopathy'
        },
        { key: 'Doctor of Pharmacy', value: 'Doctor of Pharmacy' },
        { key: 'Doctorate of Medicine', value: 'Doctorate of Medicine' },
        {
            key: 'General Nursing & Midwifery (GNM)',
            value: 'General Nursing & Midwifery (GNM)'
        },
        { key: 'Bachelor of Journalism', value: 'Bachelor of Journalism' },
        { key: 'ITI', value: 'ITI' },
        { key: 'Other', value: 'Other' }
    ],
    'Post Graduation': [
        { key: 'Master of Agriculture', value: 'Master of Agriculture' },
        { key: 'Master of Arts', value: 'Master of Arts' },
        {
            key: 'Master of Ayurvedic Medicine & Surgery - BAMS',
            value: 'Master of Ayurvedic Medicine & Surgery - BAMS'
        }
    ]
}


const filesStatusList = [
    { value: 'Student Kit & Funds Requirement Issued', text: 'Student Kit & Funds Requirement Issued' },
    { value: 'Tution Fee Pending', text: 'Tution Fee Pending' },
    { value: 'Tution Fee Received', text: 'Tution Fee Received' },
    { value: 'COE/Receipt Pending', text: 'COE/Receipt Pending' },
    { value: 'COE/Receipt Received', text: 'COE/Receipt Received' },
    { value: 'Financial Documents Pending', text: 'Financial Documents Pending' },
    { value: 'Financial Documents Received', text: 'Financial Documents Received' },
    { value: 'Verification Pending', text: 'Verification Pending' },
    { value: 'Verification Received', text: 'Verification Received' },
    { value: 'CAQ Waiting', text: 'CAQ Waiting' },
    { value: 'GIC Waiting', text: 'GIC Waiting' },
    { value: 'Final Visa File Review', text: 'Final Visa File Review' },
    { value: 'Visa File Dispatched', text: 'Visa File Submission' }
]

const visaStatusList = [
    'Visa Approved',
    'Visa Refused',
    'Visa Waiting',
    'Visa Withdrawal',
    'Refund Waiting'
]

const registrationMode = [
    { name: 'Cash Payment', value: 'Fee' },
    { name: 'Original Document Submission', value: 'Document' },
    { name: 'Reference', value: 'Reference' }
]

class CollapseViewBox extends Component {

    state = {
        cp: true
    }

    render() {
        const { cp } = this.state

        return <React.Fragment>
            <div className={cp ? styles.textarraycollapse : styles.textcollapsenot}>{this.props.children}</div>
            <button style={{ color: 'red', float: 'right' }} onClick={() => {
                this.setState({
                    cp: !cp
                })
            }}>
                {cp ? <p>View More + </p> : <p>View Less - </p>}
            </button>
        </React.Fragment>
    }
}

class StudentReport extends Component {
    state = {
        total: 0,
        allCounsellor: [],
        allAssociatePartner: [],
        channelPartnerList: [],
        allBranches: [],
        countryArr: [],
        cityArr: [],
        selectedColumns: [],
        studentReportExportRight: '',
        isFollowUpOverdue: false,
        months: [
            {
                key: '1',
                value: 'January',
            },
            {
                key: '2',
                value: 'February',
            },
            {
                key: '3',
                value: 'March',
            },
            {
                key: '4',
                value: 'April',
            },
            {
                key: '5',
                value: 'May',
            },
            {
                key: '6',
                value: 'June',
            },
            {
                key: '7',
                value: 'July',
            },
            {
                key: '8',
                value: 'August',
            },
            {
                key: '9',
                value: 'September',
            },
            {
                key: '10',
                value: 'October',
            },
            {
                key: '11',
                value: 'November',
            },
            {
                key: '12',
                value: 'December',
            }
        ],
        years: [],
        courseStartMonth: [],
        courseStartyear: []
    }


    loadCountry() {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend'
        }
        Request.getCountriesWithoutAuth(params)
            .then(resp => {
                if (resp) {
                    let temp = []
                    _.each(resp.data, (vv) => {
                        temp.push({
                            display: vv.countryName,
                            id: vv._id
                        })
                    })
                    this.setState({ countryArr: temp })

                }
            })
            .catch(err => {
            })

    }

    onCountryChoose = v => {
        this.setState({
            preferenceCountryId: v,
            preferenceCityId: []
        }, () => {
            setTimeout(() => {
                this.loadCities({ countryId: this.state.preferenceCountryId })
            }, 500)
        })
    }
    loadCities = (Obj) => {
        if (Obj) {
            return new Promise(async resolve => {
                let data = await Request.loadCitiesForCourseFinder(Obj)
                let temp = []
                _.each(data.result, (vv) => {
                    temp.push({
                        display: vv.cityName,
                        id: vv._id
                    })
                })
                this.setState({ cityArr: temp })
            })
        }
    }

    onCityChoose = v => {
        this.setState({
            preferenceCityId: v
        })
    }

    searchReset() {
        this.setState({
            preferenceCountryId: '',
            preferenceCityId: [],
            qualification: '',
            passingYear: '',
            maths: '',
            english: '',
            percentage: '',
            degreeType: '',
            major: [],
            ratingArr: [],
            stream: '',
            backlogs: '',
            cityArr: [],
            courseStartyear: '',
            courseStartMonth: ''
        }, () => {
            this.reload()
        })
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            params = this.returnNewParams(params)
            this.setState({ exportParams: params })

            if (this.state.isFollowUpOverdue) {
                params.isFollowUpOverdue = this.state.isFollowUpOverdue;
            }
            if (this.state.courseStartyear) {
                params.courseStartyear = this.state.courseStartyear;
            }

            if (this.state.courseStartMonth) {
                params.courseStartMonth = this.state.courseStartMonth;
            }

            let data = await Request.getAllStudentReport({
                ...params,
                regExFilters: ['studentName', 'profile.address', 'visaDesk.passportNo', 'mobile', 'remarks',
                    'emailId', 'facebookEmail', 'watsupp', 'whichYearPlanningToGo', 'testType', 'mailToStudent', 'family.fatherOccupation',
                    'family.motherOccupation', 'family.visaSubClasses', 'totalPreference.country',
                    'visaDesk.officerName', 'visaDesk.fileNo', 'visaDesk.selectedCourse.universityInstitutionName', 'visaDesk.selectedCourse.courseName',
                    'profile.speaking', 'profile.listening', 'profile.writing', 'profile.reading'
                ]
            })
            this.setState({
                total: data.total,
                allBranches: data.allBranches,
                studentReportExportRight: data.studentReportExportRight
            })
            resolve(data)
        })
    }

    returnNewParams(params) {
        let {
            preferenceCountryId, preferenceCityId, qualification, passingYear, maths, english, percentage,
            degreeType, major, stream, backlogs
        } = this.state
        if (preferenceCountryId) {
            params['totalPreference.countryId'] = preferenceCountryId
        }
        if (preferenceCityId) {
            params['totalPreference.cityId'] = preferenceCityId
        }
        if (qualification) {
            params['profile.newQualification.qualification'] = qualification
        }
        if (passingYear) {
            params['profile.newQualification.passingYear'] = passingYear
        }
        if (maths) {
            params['profile.newQualification.maths'] = maths
        }
        if (english) {
            params['profile.newQualification.english'] = english
        }
        if (percentage) {
            params['profile.newQualification.percentage'] = percentage
        }
        if (degreeType) {
            params['profile.newQualification.degreeType'] = degreeType
        }
        if (major && major.length) {
            params['profile.newQualification.major'] = major
        }
        if (stream) {
            params['profile.newQualification.stream'] = stream
        }
        if (backlogs) {
            params['profile.newQualification.backlogs'] = backlogs
        }
        return params
    }

    reload = () => {
        this.table.current.reload()
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.followUpsCallback = this.followUpsCallback.bind(this);
    }

    followUpExtendedDate = (followUp) => {
        if (followUp && followUp.followUpDate) {
            return moment(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')).isAfter(followUp.followUpDate);
        }
    }

    getAllRatings = async () => {
        let response = await Request.getRatingsDetails({
            results: 1000,
            count: 1000
        })
        this.setState({ ratingArr: response.data })
    }
    componentDidMount() {
        this.associatePartner()
        this.loadChannelPartners()
        this.getCounsellor()
        this.loadCountry();
        this.getAllRatings();
    }

    getOverdueClass = (generationDate) => {
        if (generationDate && moment(generationDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
            return 'red-overdue';
        }
        return '';
    }

    async getCounsellor() {

        let { data: allCounsellor } = await Request.loadUser({ results: 10000, isCounsellor: [true] })
        this.setState({
            allCounsellor
        })
    }

    async associatePartner() {
        let params = { branchAssociatePartner: 'Associate Partner', sortField: 'branchName', results: 1000 }
        let data = await Request.loadSimpleBranch({ ...params })
        let allAssociatePartner = []
        if (data && data.data && data.data.length) {
            _.each(data.data, (item) => {
                allAssociatePartner.push({ value: item._id, text: item.branchName })
            })
            this.setState({ allAssociatePartner })
        }

    }

    async loadChannelPartners() {
        let { data: channelPartnerList } = await Request.getSimplePartners({
            results: 10000
        })
        let partnerList = []
        _.each(channelPartnerList, (item) => {
            partnerList.push({ value: item._id, text: item.channelPartnerName })
        })
        this.setState({ channelPartnerList: partnerList })
    }

    followUpsCallback(isFollowUpOverdue) {
        this.setState({
            isFollowUpOverdue: isFollowUpOverdue,
        }, () => {
            this.table.current.reload()
        });
    }


    render() {
        let { allBranches,
            ratingArr,
            months,
            allAssociatePartner, allCounsellor } = this.state
        let years = [];
        let currentYear = moment().format('Y');
        for (let yr = 2018; yr <= currentYear; yr++) {
            years.push({
                key: yr,
                value: yr
            })
        }
        const columns = [

            {
                title: 'Vision ID',
                key: 'id',
                dataIndex: 'id',
                searchTextName: 'id'
            },
            {
                title: 'Student Name',
                key: 'studentName',
                dataIndex: 'studentName',
                searchTextName: 'studentName',
                filterRegex: true,
                render: (item, record) => {
                    return (
                        <div
                            className={
                                this.followUpExtendedDate(record.followUp ? record.followUp : '') ? styles.followUpExtendedDate : ''
                            }
                        >

                            {item}
                        </div>
                    )
                }
            },
            {
                title: 'DOB',
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                searchDateName: 'dateOfBirth',
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Inq Date',
                key: 'createdByUser.time',
                dataIndex: 'createdByUser.time',
                searchDateName: 'createdByUser.time',
                render: (val, record) => {
                    return (
                        <div>
                            {val
                                ? moment(val).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Inq Type',
                key: 'enqType',
                dataIndex: 'enqType',
                filters: enqTypes && enqTypes.map(x => ({ value: x, text: x })),
            },
            {
                title: 'Branch',
                key: 'studentBranchId',
                filters: allBranches,
                render: (text, record) => {
                    return (
                        <div>
                            {record.studentBranchId ? record.studentBranchId.branchName : ''}
                        </div>
                    )
                }
            },

            {
                title: 'Associate Partner',
                key: 'associativePartnerId',
                dataIndex: 'associativePartnerId',
                filters: allAssociatePartner,
                render: (text, record) => {
                    return (
                        <div>
                            {text && text.branchName ? text.branchName : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Desk',
                key: 'atLevel',
                dataIndex: 'atLevel',
                filters: atLevels && atLevels.map(x => ({ value: x.value, text: x.name })),
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            {item === 'Front Desk' ? 'Counselling Desk' : item}
                        </React.Fragment>
                    )
                }

            },
            {
                title: 'Rating',
                key: 'counsellingDesk.rating',
                dataIndex: 'counsellingDesk.rating',
                filters: ratingArr && ratingArr.map((x) => ({ value: x._id, text: x.ratingName })),
                render: (val, record) => {
                    let ratingObject = record.counsellingDesk && record.counsellingDesk.ratingObject ? record.counsellingDesk.ratingObject : null;
                    let subRatingObject = record.counsellingDesk && record.counsellingDesk.subRatingObject ? record.counsellingDesk.subRatingObject : null;
                    return (
                        <div>
                            {
                                ratingObject ?
                                    <div className="antd-pro-containers-desk-counselling-all-styles-rating" style={{ background: ratingObject.ratingColor, borderColor: ratingObject.ratingColor }}>{ratingObject.ratingName} {subRatingObject && subRatingObject.ratingName ? ('/ ' + subRatingObject.ratingName) : ''}</div>
                                    :
                                    ''
                            }
                        </div>
                    )
                },
            },
            {
                title: 'Marital Status',
                key: 'counsellingDesk.maritalStatus',
                dataIndex: 'counsellingDesk.maritalStatus',
                filters: maritalStatus && maritalStatus.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Address',
                key: 'profile.address',
                dataIndex: 'profile.address',
                searchTextName: 'profile.address'
            },
            {
                title: 'Passport No.',
                key: 'visaDesk.passportNo',
                dataIndex: 'visaDesk.passportNo',
                searchTextName: 'passport no'
            },
            {
                title: 'Gender',
                key: 'gender',
                dataIndex: 'gender',
                filters: gender && gender.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Mode',
                key: 'mode',
                dataIndex: 'mode',
                // searchTextName: 'mode',
                filterMultiple: false,
                filters: modes && modes.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Source',
                key: 'location',
                dataIndex: 'location',
                filters: sourceOptions && sourceOptions.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Mobile',
                key: 'mobile',
                dataIndex: 'mobile',
                searchTextName: 'mobile',
                filterRegex: true
            },
            {
                title: 'WhatsApp',
                key: 'watsupp',
                dataIndex: 'watsupp',
                searchTextName: 'watsupp',
                filterRegex: true

            },
            {
                title: 'Email',
                key: 'emailId',
                dataIndex: 'emailId',
                searchTextName: 'emailId'
            },
            {
                title: 'Facebook',
                key: 'facebookEmail',
                dataIndex: 'facebookEmail',
                searchTextName: 'facebookEmail'
            },
            {
                title: 'Remarks',
                key: 'remarks',
                dataIndex: 'remarks',
                searchTextName: 'remarks'
            },
            {
                title: 'Year Planning to go',
                key: 'whichYearPlanningToGo',
                dataIndex: 'whichYearPlanningToGo',
                searchTextName: 'whichYearPlanningToGo'
            },
            {
                title: 'Test Type',
                key: 'testType',
                dataIndex: 'testType',
                filterMultiple: false,
                filters: testTypes && testTypes.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Overall score',
                key: 'ieltsOverallScore',
                dataIndex: 'ieltsOverallScore',
                searchTextName: 'ieltsOverallScore'
            },
            {
                title: 'Reading score',
                key: 'profile.reading',
                dataIndex: 'profile.reading',
                searchTextName: 'profile.reading'
            },
            {
                title: 'Writing score',
                key: 'profile.writing',
                dataIndex: 'profile.writing',
                searchTextName: 'profile.writing'
            },
            {
                title: 'Listening score',
                key: 'profile.listening',
                dataIndex: 'profile.listening',
                searchTextName: 'profile.listening'
            },
            {
                title: 'Speaking score',
                key: 'profile.speaking',
                dataIndex: 'profile.speaking',
                searchTextName: 'profile.speaking'
            },
            {
                title: 'Leads to IELTS Centre',
                key: 'leadToIeltsCenter',
                dataIndex: 'leadToIeltsCenter',
                filters: confirmOptions && confirmOptions.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Send SMS',
                key: 'smsToStudent',
                dataIndex: 'smsToStudent',
                filters: confirmOptions && confirmOptions.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Send Email',
                key: 'mailToStudent',
                dataIndex: 'mailToStudent',
                filters: confirmOptions && confirmOptions.map(x => ({ value: x, text: x }))
            },

            {
                title: 'Counsellor',
                key: 'counsellorId',
                filters: allCounsellor.map(x => ({ value: x._id, text: x.name })),
                render: (text, record) => {
                    return (
                        <div>{record.counsellorId ? record.counsellorId.name : ''}</div>
                    )
                }
            },
            {
                title: 'Country',
                key: 'newTotalPreference',
                // searchTextName: 'newTotalPreference',
                filterRegex: true,
                width: 150,
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            <ul>
                                {item && item.map((v, key) => {
                                    return (
                                        <li key={key}>{v}{`, ${'\n'}`}</li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    )
                }
            },
            /*  {
                title: 'City',
                key: 'preference',
                searchTextName: 'preference',
                filterRegex: true,
                render: (val, row) => {
                  return row.totalPreference ? (
                    <ul className={common.ul}>
                      {row.totalPreference.map((val, inde) => {
                        return <li key={inde}>{val.city}</li>
                      })}
                    </ul>
                  ) : null
                }
              },*/

            {
                title: 'Qualification',
                key: 'studentQualification',
                dataIndex: 'studentQualification',
                // searchTextName: 'studentQualification',
                width: 400,
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            <ul className={styles.alternateColor}>
                                {item && item.map((v, key) => {
                                    return (
                                        <li key={key}>{v}{'\n'}</li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    )
                }
            },
            {
                title: 'Job Details',
                key: 'jobDetails',
                dataIndex: 'jobDetails',
                searchTextName: 'jobDetails',
                width: 150,
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            <ul className={styles.alternateColor}>
                                {item && item.map((v, key) => {
                                    return (
                                        <li key={key}>{v}{`, ${'\n'}`}</li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    )
                }
            },
            {
                title: 'Father Occupation',
                key: 'family.fatherOccupation',
                dataIndex: 'family.fatherOccupation',
                searchTextName: 'family.fatherOccupation'
            },
            {
                title: 'Mother Occupation',
                key: 'family.motherOccupation',
                dataIndex: 'family.motherOccupation',
                searchTextName: 'family.motherOccupation'
            },
            {
                title: 'Visa Subclass',
                key: 'family.visaSubClasses',
                dataIndex: 'family.visaSubClasses',
                searchTextName: 'family.visaSubClasses'
            },
            {
                title: 'Refer a Friend Details',
                key: 'reference',
                dataIndex: 'reference',
                searchTextName: 'reference',
                width: 120,
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            <ul>
                                {item && item.map((v, key) => {
                                    return (
                                        <li key={key}>{v}{`, ${'\n'}`}</li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    )
                }
            },
            {
                title: 'Documents Yes/No',
                key: 'visaDesk.documentsUploaded',
                dataIndex: 'visaDesk.documentsUploaded',
                filters: confirmOptions && confirmOptions.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Course Suggested',
                key: 'courseSuggested',
                searchTextName: 'courseSuggested',
                filterRegex: true,
                width: 600,
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            <ul className={styles.alternateColor}>
                                {item && item.map((v, key) => {
                                    return (
                                        <li key={key}>{v}{`, ${'\n'}`}</li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    )
                }
            },

            {
                title: 'Registration Type',
                key: 'registrationDesk.mode',
                dataIndex: 'registrationDesk.mode',
                // searchTextName: 'registrationDesk.mode'
                filters: registrationMode && registrationMode.map(x => ({ value: x.value, text: x.value }))
            },
            /*{
              title: 'Channel Partner',
              key: 'visaDesk.channelPartnerId',
              dataIndex: 'visaDesk.channelPartnerId',
              filters: channelPartnerList,
              render: (item) => {
                return (
                  <React.Fragment>
                    {item && item.channelPartnerName ? item.channelPartnerName : ''}
                  </React.Fragment>
                )
              }
            },*/
            {
                title: 'Course Selected',
                key: 'courseSelected',
                searchTextName: 'courseSelected',
                filterRegex: true,
                width: 600,
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            <ul className={styles.alternateColor}>
                                {item && item.map((v, key) => {
                                    return (
                                        <li key={key}>{v}{`, ${'\n'}`}</li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    )
                }
            },
            {
                title: 'Course Start Date',
                key: 'courseStartDate',
                // searchTextName: 'visaDesk.courseStartDate',
                // filterRegex: true,
                width: 100,
                render: (item, record) => {
                    return (
                        <div>{record.visaDesk && record.visaDesk.courseStartDate ? moment(record.visaDesk.courseStartDate).format('ll') : ''}</div>
                    )
                }
            },
            {

                title: 'Student ID',
                key: 'instituteStudentId',
                dataIndex: 'instituteStudentId',
                searchTextName: 'instituteStudentId'
            },
            {
                title: 'Last updated by',
                key: 'updatedByUser.name',
                dataIndex: 'updatedByUser.name',
                // searchTextName: 'updatedByUser.name',
                filters: allCounsellor.map(x => ({ value: x.name, text: x.name }))
            },
            {
                title: 'Activity Type',
                key: 'act',
                dataIndex: 'act',
                searchTextName: 'act'
            },
            {
                title: 'Follow Up Type',
                key: 'followUp.followUpType',
                dataIndex: 'followUp.followUpType',
                filters: followUpTypeArr && followUpTypeArr.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Note added by',
                key: 'followUp.assignByName',
                dataIndex: 'followUp.assignByName',
                filters: allCounsellor.map(x => ({ value: x.name, text: x.name }))
                // searchTextName: 'followUp.assignByName'

            },
            {
                title: 'Visa File Status',
                key: 'visaDesk.fileStatus',
                dataIndex: 'visaDesk.fileStatus',
                filters: filesStatusList && filesStatusList.map(x => ({ value: x.value, text: x.text })),
                render: (val, record) => {
                    return record.visaDesk.fileStatus === 'Visa File Dispatched' ? 'Visa File Submission' : record.visaDesk.fileStatus
                }
            },
            {
                title: 'Submission Date',
                key: 'visaDesk.submissionDate',
                dataIndex: 'visaDesk.submissionDate',
                searchDateName: 'visaDesk.submissionDate',
                render: (val, record) => {
                    return (
                        <div>
                            {record && record.visaDesk && record.visaDesk.submissionDate
                                ? moment(record && record.visaDesk.submissionDate).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Officer Name',
                key: 'visaDesk.officerName',
                dataIndex: 'visaDesk.officerName',
                searchTextName: 'visaDesk.officerName'
            },
            {
                title: 'File Number',
                key: 'visaDesk.fileNo',
                dataIndex: 'visaDesk.fileNo',
                searchTextName: 'visaDesk.fileNo'
            },
            {
                title: 'Visa Status',
                key: 'visaDesk.visaStatus',
                dataIndex: 'visaDesk.visaStatus',
                filters: visaStatusList && visaStatusList.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Visa Date',
                key: 'visaDesk.visaDate',
                dataIndex: 'visaDesk.visaDate',
                searchDateName: 'visaDesk.visaDate',
                render: (val, record) => {
                    return (
                        <div>
                            {record && record.visaDesk && record.visaDesk.visaDate
                                ? moment(record.visaDesk.visaDate).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Arrival Date',
                key: 'visaDesk.arrivalDate',
                dataIndex: 'visaDesk.arrivalDate',
                searchDateName: 'visaDesk.arrivalDate',
                render: (val, record) => {
                    return (
                        <div>
                            {record && record.visaDesk && record.visaDesk.arrivalDate
                                ? moment(record.visaDesk.arrivalDate).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Final Course Selected',
                key: 'visaDesk.selectedCourse.courseName',
                dataIndex: 'visaDesk.selectedCourse',
                searchTextName: 'visaDesk.selectedCourse.courseName',
                render: (val, record) => {
                    return (
                        <div>
                            {record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.courseName}
                        </div>
                    )
                }

            },
            {
                title: 'Final University Selected',
                key: 'visaDesk.selectedCourse.universityInstitutionName',
                dataIndex: 'visaDesk.selectedCourse',
                searchTextName: 'visaDesk.selectedCourse.universityInstitutionName',
                render: (val, record) => {
                    return (
                        <div>
                            {record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.universityInstitutionName}
                        </div>
                    )
                }
            },
            {
                title: 'Invoicee Type',
                key: 'leadSource',
                dataIndex: 'leadSource',
                filters: invoiceTypesList && invoiceTypesList.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Invoicee Name',
                key: 'visaDesk.channelPartnerId',
                dataIndex: 'visaDesk.channelPartnerId',
                // filters: channelPartnerList,
                render: (item, record) => {
                    return (
                        <span>
                            {record && record.leadSource === 'University' ?
                                <div>
                                    {record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.universityInstitutionName}
                                </div> : null}
                            {record && record.leadSource === 'Channel Partner' ?
                                <div>
                                    {item && item.channelPartnerName ? item.channelPartnerName : ''}
                                </div> : null}

                        </span>
                    )
                }
                // searchTextName: 'leadSource'
            },
            {
                title: 'Student Status',
                key: 'studentStatus',
                dataIndex: 'studentStatus',
                filters: studentStatus && studentStatus.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Invoice Generation Dates',
                key: 'invoiceGenerationDates',
                dataIndex: 'invoiceGenerationDates',
                searchDateName: 'invoiceGenerationDates',
                width: 250,
                render: (item, record) => (
                    <React.Fragment>
                        {
                            record.nextInvoiceGenerationDates && record.nextInvoiceGenerationDates.length > 0 ?
                                <table className='ant-table ant-table-bordered' style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Invoice</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            record.nextInvoiceGenerationDates.map((date, index) => {
                                                let url = `/desk/getClaim?id=${(record._id)}`;
                                                return (
                                                    <tr key={index} className={(date.invoiceGeneratedNumber ? 'invoice-done' : this.getOverdueClass(date.generationDate) == 'red-overdue' ? 'red-overdue' : 'pending-invoice')}>
                                                        <td>
                                                            {
                                                                date.invoiceGeneratedNumber ?
                                                                    <small><a
                                                                        target={"_blank"}
                                                                        href={url}
                                                                    >
                                                                        {date.invoiceGeneratedNumber}
                                                                    </a></small>
                                                                    :
                                                                    'To Be Invoiced'
                                                            }
                                                        </td>
                                                        <td>{moment(date.generationDate).format(dateFormat)}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                :
                                <small style={{ color: '#ed1c24', fontSize: '12px' }}>Dates Not Added Yet!!!.</small>
                        }
                    </React.Fragment>
                )
            },
            {
                title: 'Total No. of Terms',
                key: 'dueInvoiceCount',
                dataIndex: 'dueInvoice',
                searchTextName: 'dueInvoiceCount',
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            {record && record.invoiceGenerationDates ? record.invoiceGenerationDates.length : null}
                        </React.Fragment>
                    )
                }
            }
        ];
        const excelFields = {
            "createdByUser.time": "Inq Date",
            "studentBranchId.branchName": "Branch",
            atLevel: "Desk",
            id: "Vision Id",
            studentName: "Student Name",
            "counsellingDesk.ratingObject.ratingName": "Rating",
            "counsellingDesk.maritalStatus": "Marital Status",
            "profile.address": "Address",
            "visaDesk.passportNo": "Pasport No",
            dateOfBirth: "Date of Birth",
            gender: "Gender",
            mode: "Mode",
            location: "source",
            mobile: "Mobile",
            "profile.landline": "Alternate Number",
            watsupp: "Whatsapp",
            emailId: "Email",
            facebookEmail: "Facebook Email",
            remarks: "Remarks",
            whichYearPlanningToGo: "Which Year Planning to go",
            testType: "Test Type",
            ieltsOverallScore: "Overall Score",
            "profile.reading": "Reading Score",
            "profile.writing": "Writing Score",
            "profile.listening": "Listening Score",
            "profile.speaking": "Speaking Score",
            leadToIeltsCenter: "Lead To Ielts Center",
            smsToStudent: "Send SMS",
            mailToStudent: "Send Email",
            "counsellorId.name": "Counsellor Name",
            newTotalPreference: "Country",
            studentQualification: "Qualification",
            jobDetails: "Job Details",
            "family.fatherOccupation": "Father Occupation",
            "family.motherOccupation": "Mother Occupation",
            "family.visaSubClasses": "Visa Sub Classes",
            reference: "Reference a friend details",
            "visaDesk.documentsUploaded": "Visa documents YES/NO",
            courseSuggested: "Course Suggested",
            "registrationDesk.mode": "Registration Mode",
            courseSelected: "Course Selected",
            instituteStudentId: "Institute Student Id",
            "updatedByUser.name": "Last Updated By User",
            act: "Activity",
            "followUp.followUpType": "Follow Up Type",
            "followUp.assignByName": "Assign By added by",
            "visaDesk.fileStatus": "Visa file status",
            "visaDesk.submissionDate": "Visa submission date",
            "visaDesk.officerName": "Visa officer name",
            "visaDesk.fileNo": "Visa file no",
            "visaDesk.visaStatus": "Visa status",
            "visaDesk.visaDate": "Visa date",
            "visaDesk.arrivalDate": "Arrival date",
            "visaDesk.selectedCourse.courseName": "Final course selected",
            "visaDesk.courseStartDate": "Course Start Date",
            "visaDesk.selectedCourse.universityInstitutionName":
                "Final university selected",
            leadSource: "Invoicee Type",
            studentStatus: "Student status",
            invoiceGenerationDates: "Invoice generation date",
            dueInvoice: "invoice",
            invoiceStatus: "Invoice status",
        };
        let selectedColumnHtml = [];
        for (let key in excelFields) {
            selectedColumnHtml.push(<Option value={key}>{excelFields[key]}</Option>);
        }
        return (
            <PageHeaderWrapper title={`
          Total Students : ${this.state.total}`}
                followUpsCallback={this.followUpsCallback}
            >
                <Card style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={4}>
                            <h4>Search By Country</h4>
                            <Select
                                allowClear
                                mode={'multiple'}
                                className={common.width100Pr}
                                showSearch={true}
                                value={this.state.preferenceCountryId}
                                placeholder="Select Country"
                                optionFilterProp="display"
                                onChange={this.onCountryChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {this.state.countryArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={4}>
                            <h4>Search By City</h4>
                            <Select
                                allowClear
                                mode={'multiple'}
                                showSearch={true}
                                className={common.width100Pr}
                                value={this.state.preferenceCityId}
                                placeholder="Select City"
                                optionFilterProp="display"
                                onChange={this.onCityChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {this.state.cityArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={4}>
                            <h4>Search By Qualification</h4>
                            <Select
                                allowClear
                                showSearch={true}
                                value={this.state.qualification}
                                className={common.width100Pr}
                                placeholder="Select Qualification"
                                onChange={qualification => {
                                    this.setState({
                                        qualification
                                    })
                                }}>
                                <Option value={'X'}>X</Option>
                                <Option value={'XII'}>XII</Option>
                                <Option value={'Diploma'}>Diploma</Option>
                                <Option value={'Bachelor Degree'}>Bachelor Degree</Option>
                                <Option value={'Post Graduation'}>Post Graduation</Option>
                            </Select>
                        </Col>
                        <Col span={4}>
                            <label className={styles.test}>Passing year</label>
                            <InputNumber
                                allowClear
                                value={this.state.passingYear}
                                maxLength={4}
                                placeholder={'Passing year'}
                                className={common.width100Pr}
                                onChange={py => {
                                    this.setState({ passingYear: py })
                                }}
                            />
                        </Col>
                        <Col span={4}>
                            <label className={styles.test}>% or Grade</label>
                            <InputNumber
                                allowClear
                                value={this.state.percentage}
                                placeholder={'% or Grade'}
                                className={common.width100Pr}
                                onChange={py => {
                                    this.setState({ percentage: py })
                                }}
                            />
                        </Col>

                        <Col span={4}>
                            <label className={styles.test}>Math Score</label>
                            <InputNumber
                                allowClear
                                value={this.state.maths}
                                placeholder={'Math Score'}
                                className={common.width100Pr}
                                onChange={py => {
                                    this.setState({ maths: py })
                                }}
                            />
                        </Col>


                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col span={4}>
                            <label className={styles.test}>English Score</label>
                            <InputNumber
                                allowClear
                                value={this.state.english}
                                placeholder={'English Score'}
                                className={common.width100Pr}
                                onChange={py => {
                                    this.setState({ english: py })
                                }}
                            />
                        </Col>
                        <Col span={4}>
                            <h4>Search By Stream</h4>
                            <Select
                                allowClear
                                mode={'tags'}
                                value={this.state.stream}
                                showSearch={true}
                                placeholder="Select Stream"
                                className={common.width100Pr}
                                onChange={streams => {
                                    this.setState({ stream: streams })
                                }}>
                                <Option value={'Medical'}>SCIENCE-MEDICAL</Option>
                                <Option value={'NonMedical'}>SCIENCE-NON MEDICAL</Option>
                                <Option value={'Commerce'}>COMMERCE</Option>
                                <Option value={'Arts'}>ARTS</Option>
                            </Select>
                        </Col>
                        <Col span={4}>
                            <label className={styles.test}>Major Subjects</label>
                            <Select
                                allowClear
                                mode="tags"
                                className={common.width100Pr}
                                placeholder={'Major Subjects'}
                                value={this.state.major}
                                onChange={ss => {
                                    this.setState({ major: ss })
                                }}
                            />
                        </Col>
                        <Col span={4}>
                            <label className={styles.test}>Backlogs</label>
                            <InputNumber
                                allowClear
                                value={this.state.backlogs}
                                placeholder={'Backlogs'}
                                className={common.width100Pr}
                                onChange={py => {
                                    this.setState({ backlogs: py })
                                }}
                            />
                        </Col>
                        <Col span={4}>
                            <h4>Search By Degree</h4>
                            <Select
                                allowClear
                                showSearch={true}
                                value={this.state.degreeType}
                                className={common.width100Pr}
                                placeholder="Select Degree"
                                onChange={degreeType => {
                                    this.setState({ degreeType })
                                }}>
                                {this.state.qualification && typeofDegree[this.state.qualification] && typeofDegree[this.state.qualification].map((val, index) => {
                                    return (
                                        <Option key={index} value={val.value}>
                                            {val.value}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={4}>
                            <h4>Search By Year & Month</h4>
                            <Select
                                allowClear
                                showSearch={true}
                                mode='multiple'
                                value={this.state.courseStartyear}
                                className={common.width100Pr}
                                placeholder="Select Year"
                                style={{ marginBottom: '5px' }}
                                onChange={courseStartyear => {
                                    this.setState({ courseStartyear })
                                }}>
                                {years && years.map((year, index) => {
                                    return (
                                        <Option key={index} value={year.key}>
                                            {year.value}
                                        </Option>
                                    )
                                })}
                            </Select>

                            <Select
                                allowClear
                                showSearch={true}
                                mode='multiple'
                                value={this.state.courseStartMonth}
                                className={common.width100Pr}
                                placeholder="Select Month"
                                onChange={courseStartMonth => {
                                    this.setState({ courseStartMonth })
                                }}>
                                {months && months.map((month, index) => {
                                    return (
                                        <Option key={index} value={month.key}>
                                            {month.value}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={6} className={styles.groupBtn}>
                            <Button type={'default'}
                                loading={this.props.loading}
                                onClick={() => {
                                    this.searchReset()
                                }}>Reset</Button>
                            <Button type={'default'}
                                loading={this.props.loading}
                                onClick={() => {
                                    this.reload()
                                }}>Search</Button>
                        </Col>
                    </Row>
                </Card>

                {
                    userRights.checkRights("StudentReportExcelExport.view") ?
                        <Card style={{ marginBottom: 10 }}>
                            <Row style={{ marginTop: 10 }}>
                                <Col span={18} className={styles.groupBtn}>
                                    <Select
                                        allowClear
                                        mode={'tags'}
                                        value={this.state.selectedColumns}
                                        showSearch={true}
                                        placeholder="Select Columns"
                                        className={common.width100Pr}
                                        onChange={selectedColumns => {
                                            this.setState({ selectedColumns: selectedColumns })
                                        }}>
                                        {selectedColumnHtml}
                                    </Select>
                                </Col>

                            </Row>
                        </Card>
                        : null
                }
                <Card bordered={true}>
                    <TableComp
                        id={"studentReport"}
                        columns={columns}
                        extraProps={{ scroll: { x: 9400 } }}
                        ref={this.table}
                        showSelector={true}
                        useFixedHeader={true}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentReport)
